import React from 'react';
import O2KineticsGrid from './O2KineticsGrid';

/**
 * O2 Kinetics workspace — renders the responsive grid of editable O2K plots.
 * Full O2K UI (transition list, fit params, results) will be redesigned later.
 */
const O2KineticsWorkspace = ({ tabId }) => {
  return <O2KineticsGrid tabId={tabId} />;
};

export default O2KineticsWorkspace;
